import type { ReactNode } from 'react';

interface WidgetCardProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}

export function WidgetCard({ title, action, children }: WidgetCardProps) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white shadow-sm flex flex-col overflow-hidden">
      <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3 sm:px-5 sm:py-4">
        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
        {action ? <div className="flex items-center gap-2">{action}</div> : null}
      </div>
      <div className="flex-1 p-4 sm:p-5">{children}</div>
    </div>
  );
}
